
import { computed, defineComponent } from "vue";
import Messages from "@/Components/General/Messages.vue";
import Button from "@/Components/Buttons/Button.vue";
import {
  mdiAccountMultipleOutline,
  mdiAccountOutline,
  mdiApplicationImport,
  mdiBookOpen,
  mdiCartVariant,
  mdiClipboardTextOutline,
  mdiClockTimeFourOutline,
  mdiFormatListText,
  mdiHistory,
  mdiMenu,
  mdiMonitor,
  mdiPoll,
  mdiWeb,
} from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import { useStore } from "@/stores/main";
import {
  ref,
  onMounted,
  onBeforeUnmount,
  onBeforeMount,
} from "@vue/runtime-core";
import { Inertia } from "@inertiajs/inertia";
import {
  RouteParams,
} from "ziggy-js";

export default defineComponent({
  props: {
    countWebOrders: { type: Number, required: false },
  },
  setup(props: any) {
    const store = useStore();
    const countWebOrders = ref(props.countWebOrders);
    const notificationPollingInterval = ref<any>(null);
    const reloadCountWebOrders = () => {
      Inertia.reload({ only: ["countWebOrders"] });
      countWebOrders.value = props.countWebOrders;
    };
    const link = (
      routeName: string,
      params?: RouteParams
    ) => {
      return route(routeName, params);
    };

    onMounted(() => {
      notificationPollingInterval.value = setInterval(() => {
        reloadCountWebOrders();
      }, 5000);
    });
    onBeforeUnmount(() => {
      clearInterval(notificationPollingInterval.value);
    });

    return {
      link,
      webstoreLink: computed(() => store.wcBaseUrl),
      openOrdersIcon: mdiFormatListText,
      webordersIcon: mdiMonitor,
      previousOrdersIcon: mdiHistory,
      productListIcon: mdiMenu,
      customerListIcon: mdiAccountMultipleOutline,
      newCustomerIcon: mdiAccountOutline,
      backorderListIcon: mdiClipboardTextOutline,
      hoursIcon: mdiClockTimeFourOutline,
      newRegistryIcon: mdiPoll,
      webstoreIcon: mdiCartVariant,
      countWebOrders,
    };
  },
  layout: AppLayoutVue,
  components: { Messages, Button, SvgIcon },
});
